/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { WaterFaucet, WaterFaucetInterface } from "../WaterFaucet";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "PAPER_POT_ADDRESS_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint24[]",
        name: "tokenIds",
        type: "uint24[]",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint24[]",
        name: "tokenIds_",
        type: "uint24[]",
      },
    ],
    name: "claim",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getCutoffTimes",
    outputs: [
      {
        components: [
          {
            internalType: "uint24",
            name: "startTime1",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "endTime1",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "startTime2",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "endTime2",
            type: "uint24",
          },
        ],
        internalType: "struct WaterFaucet.CutoffTimes",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "p",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint24",
            name: "startTime1",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "endTime1",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "startTime2",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "endTime2",
            type: "uint24",
          },
        ],
        internalType: "struct WaterFaucet.CutoffTimes",
        name: "cutoffTimes_",
        type: "tuple",
      },
    ],
    name: "setCutoffTimes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type WaterFaucetConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WaterFaucetConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WaterFaucet__factory extends ContractFactory {
  constructor(...args: WaterFaucetConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    PAPER_POT_ADDRESS_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WaterFaucet> {
    return super.deploy(
      PAPER_POT_ADDRESS_,
      overrides || {}
    ) as Promise<WaterFaucet>;
  }
  getDeployTransaction(
    PAPER_POT_ADDRESS_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(PAPER_POT_ADDRESS_, overrides || {});
  }
  attach(address: string): WaterFaucet {
    return super.attach(address) as WaterFaucet;
  }
  connect(signer: Signer): WaterFaucet__factory {
    return super.connect(signer) as WaterFaucet__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WaterFaucetInterface {
    return new utils.Interface(_abi) as WaterFaucetInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WaterFaucet {
    return new Contract(address, _abi, signerOrProvider) as WaterFaucet;
  }
}
